import { useMutation, gql, MutationHookOptions } from "@apollo/client";

export type InsertGroupInput = {
  id?: string;
  name: string;
  companyId: string;
  description: string;
  type: string;
};

export const INSERT_GROUP = gql`
  mutation insertGroup($input: InsertGroupInput!) {
    insertGroup(input: $input) {
      group {
        id
      }
    }
  }
`;

export default (options?: MutationHookOptions<any, Record<string, any>>) => {
  return useMutation(INSERT_GROUP, options);
};
